export default function propsAreEqual<T extends object>(a: T, b: T, keys: Array<keyof T>) {
    return keys.every(k => a[k] === b[k]);
}